import React from "react";
import { Container, Stack } from "@mui/material";
import PartsCatalogView from "../components/PartsCatalogView";

export default function PartsCatalogPage() {
  return (
    <Container sx={{ py: 4 }}>
      <Stack spacing={3}>
        <PartsCatalogView />
      </Stack>
    </Container>
  );
}
